import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	blocks: {
		id: 'roadmap.timeline-table-kit.edit-dependency-modal.unlink-dependency-button.blocks',
		defaultMessage: 'Blocks',
		description: 'Label for issue dependencies with the "Blocks" link type.',
	},
	blockedBy: {
		id: 'roadmap.timeline-table-kit.edit-dependency-modal.unlink-dependency-button.blocked-by',
		defaultMessage: 'Is blocked by',
		description: 'Label for issue dependencies with the "Is blocked by" link type.',
	},
	unlink: {
		id: 'roadmap.timeline-table-kit.edit-dependency-modal.unlink-dependency-button.unlink',
		defaultMessage: 'Unlink',
		description:
			'Label for button that removes an existing link between two issues via the edit dependency modal in the project timeline.',
	},
	unlinkAriaLabel: {
		id: 'roadmap.timeline-table-kit.edit-dependency-modal.unlink-dependency-button.unlink-aria-label',
		defaultMessage:
			'Unlink dependency, Current issue {linkType} Issue {issueType} {issueKey} {issueSummary}',
		description:
			'Aria label for the unlink button which removes the dependency between two issues.',
	},
	unlinkAriaLabelIssueTermRefresh: {
		id: 'roadmap.timeline-table-kit.edit-dependency-modal.unlink-dependency-button.unlink-aria-label-issue-term-refresh',
		defaultMessage:
			'Unlink dependency, Current work item {linkType} Work item {issueType} {issueKey} {issueSummary}',
		description:
			'Aria label for the unlink button which removes the dependency between two issues.',
	},
});
